module.exports = __webpack_public_path__ + "img/AE5002-112.ecf7ecf7.jpg";